'use client';
import { nextBrowser, useBP } from 'scripts';
import { CSSProperties, useEffect, useMemo, useRef } from 'react';
import { Drawer, Modal, Spin } from 'antd';
import { __PostContactPropsType } from './postContact.type';
import dynamic from 'next/dynamic';
import { __SocialMedias } from 'aloEjare/panel/postForm/socialMedia/socialMedia.data';
import { COLORS } from 'utilities';
import Meta from 'antd/es/card/Meta';

export default function PostContactComp(props: __PostContactPropsType) {
    const isMobile = useBP()?.MD_LTE;
    const onCloseRef = useRef(props.onClose);
    onCloseRef.current = props.onClose;

    useEffect(() => {
        if (!isMobile || !props.open) return;

        window.history.pushState({ postContactDrawer: true }, '');

        const onPopState = () => {
            onCloseRef.current();
        };

        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, [isMobile, props.open]);

    const handleClose = () => {
        if (isMobile) {
            window.history.back();
            return;
        }
        props.onClose();
    };
    const post = props.post;
    const social = (name: string) => __SocialMedias.find((i) => i.name === name);
    const url =
        !post.latitude || !post.longitude
            ? 'https://maps.google.com/maps?q=' + post.address
            : isMobile
              ? `geo:${post.latitude},${post.longitude}?q=${post.latitude},${post.longitude}`
              : `https://maps.google.com/maps?q=${post.latitude},${post.longitude}`;
    // const longPressEvent = useLongPress(
    //     () => {
    //         if (post.address) {
    //             CopyToClipboard(post.address);
    //             message.success('نشانی با موفقیت در کلیپ بورد ذخیره شد');
    //         }
    //     },
    //     () => nextBrowser.window?.open(url),
    //     { delay: 200 },
    // );

    const Map = useMemo(
        () =>
            dynamic(() => import('components/locationPicker/locationPicker.index'), {
                loading: () => (
                    <div className={`w-100 pv-9 center-content flex-1`}>
                        <Spin />
                    </div>
                ),
                ssr: false,
            }),
        [],
    );

    const style: CSSProperties = {
        borderRadius: 10,
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: COLORS.lightGreen,
        color: COLORS.primary,
        minWidth: 120,
        padding: '12px 12px',
    };

    const content = (
        <>
            <div style={{ gap: 16, flexWrap: 'wrap' }} className={`center-content-x mb-3`}>
                {post.has_phone && post.phone?.length ? (
                    <a target="_blank" href={'tel:' + post.phone} style={style}>
                        تماس تلفنی
                    </a>
                ) : null}
                {Object.entries(post.socials ?? '{}')
                    .filter((i) => i[1].length)
                    .map((item, index) =>
                        social(item[0]) ? (
                            <a key={index} aria-label={item[0]} target="_blank" href={item[1] as string} style={style}>
                                {social(item[0])?.label}
                            </a>
                        ) : null,
                    )}
            </div>
            <Meta
                title={<p className="t-h3 t-l-black1 t-d-gray3 t-500">نشانی</p>}
                description={
                    post.address?.length
                        ? post.address.split('\n').map((a, i) => (
                              <p key={i} className="t-p2 t-l-black1 t-d-gray2 t-400 pb-1">
                                  {a}
                              </p>
                          ))
                        : null
                }
            />
            <div className="w-100 mb-4 d-block" onDoubleClick={() => nextBrowser.window?.open(url)}>
                <Map
                    latitude={post.latitude}
                    longitude={post.longitude}
                    zoomControl={false}
                    attributionControl={false}
                />
            </div>
        </>
    );

    return isMobile ? (
        <Drawer placement="bottom" open={props.open} onClose={handleClose} title="اطلاعات تماس" height={500}>
            {content}
        </Drawer>
    ) : (
        <Modal
            title="اطلاعات تماس"
            onCancel={props.onClose}
            onClose={props.onClose}
            open={props.open}
            height={'auto'}
            footer={<></>}
            // onOk={props.onClose}
            // okButtonProps={{ type: 'default' }}
            // cancelButtonProps={{ className: 'd-none-i' }}
        >
            {content}
        </Modal>
    );
}
